import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

// Color principal verde
const HEALTH_GREEN = '#4CAF50';

const UserTypeSelector = ({ userType, onUserTypeChange }) => {
  const handleTabClick = (value) => {
    onUserTypeChange(value);
  };

  return (
    <Paper
      elevation={0}
      sx={{
        mb: 3,
        borderRadius: '50px',
        overflow: 'hidden',
        position: 'relative',
        background: (theme) => theme.palette.mode === 'dark' 
          ? 'rgba(255,255,255,0.05)' 
          : 'rgba(0,0,0,0.02)',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          position: 'relative',
          p: 0.5,
          gap: 0.5,
        }}
      >
        {/* Indicador deslizante blanco */}
        <Box
          sx={{
            position: 'absolute',
            top: 4,
            left: userType === 'center' ? 4 : 'calc(50% + 2px)',
            width: 'calc(50% - 6px)',
            height: 'calc(100% - 8px)',
            background: '#FFFFFF',
            borderRadius: '50px',
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            boxShadow: '0 1px 4px rgba(0, 0, 0, 0.1)',
            zIndex: 1,
          }}
        />

        {/* Tab Health Center */}
        <Box
          onClick={() => handleTabClick('center')}
          sx={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            py: 1,
            px: 2,
            borderRadius: '50px',
            cursor: 'pointer',
            transition: 'all 0.2s ease',
            position: 'relative',
            zIndex: 2,
            '&:hover': {
              backgroundColor: userType !== 'center' 
                ? (theme) => theme.palette.mode === 'dark' 
                  ? 'rgba(255,255,255,0.05)' 
                  : 'rgba(0,0,0,0.03)'
                : 'transparent',
            }
          }}
        >
          <Typography 
            variant="body2" 
            sx={{ 
              fontWeight: userType === 'center' ? 600 : 500,
              color: userType === 'center' ? HEALTH_GREEN : '#666666',
              transition: 'color 0.2s ease',
              fontSize: '0.875rem',
            }}
          >
            Health Center
          </Typography>
        </Box>

        {/* Tab Independent */}
        <Box
          onClick={() => handleTabClick('independent')}
          sx={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            py: 1,
            px: 2,
            borderRadius: '50px',
            cursor: 'pointer',
            transition: 'all 0.2s ease',
            position: 'relative',
            zIndex: 2,
            '&:hover': {
              backgroundColor: userType !== 'independent' 
                ? (theme) => theme.palette.mode === 'dark' 
                  ? 'rgba(255,255,255,0.05)' 
                  : 'rgba(0,0,0,0.03)'
                : 'transparent',
            }
          }}
        >
          <Typography 
            variant="body2" 
            sx={{ 
              fontWeight: userType === 'independent' ? 600 : 500,
              color: userType === 'independent' ? HEALTH_GREEN : '#666666',
              transition: 'color 0.2s ease',
              fontSize: '0.875rem',
            }}
          >
            Independent
          </Typography>
        </Box>
      </Box>
    </Paper>
  );
};

export default UserTypeSelector;